import {
  IGetArticleListResponse,
  // IGetArticleListResponseError
} from '../repositories/backend-content/v1/get-content-item';

export function mapGetArticleListResponse(response: IGetArticleListResponse) {
  return {
    statusCode: 200,
    response,
  };
}

// export function mapGetArticleListErrorResponse({ message }: IGetArticleListResponseError) {
//   return {
//     statusCode: 400,
//     response: message,
//   };
// }
